module.exports = __webpack_public_path__ + "img/driving_style_de.b5783967.svg";